import React, { useContext, useState } from 'react'
import PropTypes from 'prop-types'
import { XCircleIcon } from '@heroicons/react/24/solid'

// Icons
import { TrashIcon } from '../../components/TrashIcon'

// Components
import { Modal } from '../../components/Modal'
import { VerificationCodeInput } from '../../components/VerificationCodeInput'

// Store
import { NavigationStoreContext } from '../../stores/NavigationStore'

// Utils & Service
import { deleteBadge } from '../../services/badges.service'
import { toast } from '../../utils/helpers'

const DeleteBadgeModal = ({
  adminPassword,
  badgeConfiguration,
  eventStatus,
  resetBadge,
  setShow,
}) => {
  // Context
  const { event } = useContext(NavigationStoreContext)

  // State
  const [loading, setLoading] = useState(false)
  const [password, setPassword] = useState(null)
  const [showPasswordError, setShowPasswordError] = useState(false)

  const handleSuccess = (message) => toast(message, 'success')
  const handleError = (message) => toast(message, 'error')

  return (
    <Modal
      actions={[
        {
          type: 'cancel',
          label: 'Cancel',
          onClick: () => setShow(false),
        },
        {
          type: 'submit',
          label: 'Delete Badge',
          onClick: () => {
            // Prevent badge deletion if the event is active and password is not provided
            if (eventStatus === 'Active' && (!password || password !== adminPassword)) {
              setShowPasswordError(true)
              return
            }

            if (badgeConfiguration?.id) {
              deleteBadge(event.id, badgeConfiguration.id, handleError, setLoading, async (m) => {
                handleSuccess(m)
                resetBadge()
              })
            }
          },
          background: 'bg-red',
        },
      ]}
      icon={<TrashIcon className="h-6 fill-white" />}
      iconBackground="bg-red"
      content={
        <div className="mt-3 flex flex-col text-center text-sm sm:mt-5">
          <p>Deleting this badge is irreversible. Are you sure you want to continue?</p>

          <div className="mt-4 flex flex-col items-center">
            <VerificationCodeInput
              maskInput
              backgroundColor="white"
              borderColor="gray"
              fontColor="black"
              error={
                showPasswordError && (
                  <div className="flex items-center gap-2 rounded-lg bg-error-light px-4 py-2 font-medium text-error-dark">
                    <span className="h-5 w-5">
                      <XCircleIcon className="text-error-icon" />
                    </span>
                    Valid password is required.
                  </div>
                )
              }
              handleSubmitCode={(p) => setPassword(p)}
              inputStyle="separated"
              containerStyles={{ alignItems: 'center' }}
              codeLength={4}
            />
          </div>
        </div>
      }
      loading={loading}
      open
      title="Delete Badge?"
    />
  )
}

DeleteBadgeModal.propTypes = {
  adminPassword: PropTypes.string.isRequired,
  badgeConfiguration: PropTypes.object.isRequired,
  eventStatus: PropTypes.string.isRequired,
  resetBadge: PropTypes.func.isRequired,
  setShow: PropTypes.func.isRequired,
}

export default DeleteBadgeModal
